import { Immutable } from "@hookstate/core";
import { forwardRef, useMemo } from "react";
import { FilterTagButton } from "../../../../components/buttons/FilterTag";
import { ComicContributorTypeEntity } from "../../../../services/gc/types";
import { Option } from "../../../../types";
import { FilterTitle } from "../../../../components/filters/FilterTitle";
import { RadioFilter } from "../../../../components/filters/RadioFilter";

export const COMIC_CONTRIBUTOR_TYPE_ALL = "0";

interface ComicContributorTypeFilterProps {
  value: Immutable<string | undefined>;
  comicContributorTypes: ComicContributorTypeEntity[];
  onChange: (nextValue: string) => void;
  tinted?: boolean;
}
export function ComicContributorTypeFilter({
  value,
  comicContributorTypes,
  onChange,
  tinted,
}: ComicContributorTypeFilterProps) {
  const categoryOptions: Option<string>[] = useMemo(
    () => [
      { label: "All", value: COMIC_CONTRIBUTOR_TYPE_ALL },
      ...comicContributorTypes.map((type) => ({
        label: type.name,
        value: "" + type.id,
      })),
    ],
    [],
  );

  return (
    <RadioFilter value={value} options={categoryOptions} onChange={onChange} tinted={tinted} />
  );
}

interface ComicContributorTypeFilterTitleProps {
  isTrigger: boolean;
  comicContributorTypes: ComicContributorTypeEntity[];
  activeValue?: Immutable<string | undefined>;
  open: boolean;
}
export const ComicContributorTypeFilterTitle = forwardRef(
  (
    {
      isTrigger,
      comicContributorTypes,
      activeValue,
      open,
      ...props
    }: ComicContributorTypeFilterTitleProps,
    ref,
  ) => {
    const comicContributorType = comicContributorTypes.find(
      (type) => `${type.id}` == activeValue,
    );
    if (isTrigger) {
      return (
        <FilterTagButton
          popoverRef={ref}
          text="Contributor"
          isFiltering={comicContributorType?.name}
          {...props}
        />
      );
    }
    return (
      <FilterTitle
        text="Contributor"
        open={open}
      />
    );
  },
);
